import { TbSum } from "react-icons/tb";
import CardLayout from "../../common/CardLayout";
import TitleCardSimple from "../../common/TitleCardSimple";

import ChartBarViewDefault from "./charts/ChartBarDefault";

const ConsumoSalaMaquinas = ({ dados }) => {

  const valores = dados.map(
    (elemento) => elemento.potenciaSalaMaquinasKw * 0.25
  );
  const soma = valores.reduce((a, b) => a + b, 0) ?? 0;
  
function organizarConsumoPorHora(arrayDeDados) {
  const resultado = Array.from({ length: 24 }, (_, hora) => ({
    hora,
    valor: 0
  }));

  arrayDeDados.forEach(item => {
    const data = new Date(item.dataHora);
    const hora = data.getHours();
    resultado[hora].valor += item.consumoSalaMaquinas;
  });
  
  return resultado;
}

const resultadoFinal = organizarConsumoPorHora(dados);

function formatarHora(numero) {
  return numero.toString().padStart(2, '0') + ':00';
}

const res = {
  date: resultadoFinal.map((elemento) => {
    return formatarHora(elemento.hora)
  }),
  valor: resultadoFinal.map(item => item.valor)
}


return (
    <>
      <CardLayout>
        <div className="flex justify-between h-full flex-col items-center px-4">
          <div className="flex-col justify-center items-center flex-coltext-white text-sm lg:text-lg">
            <TitleCardSimple>Consumo Sala de Máquinas </TitleCardSimple>
            <div className="flex">
              <p className="py-2 flex items-center px-2 lg:text-lg">
                Acumulado total
                <TbSum className="h-5 w-5 pl-1" />
              </p>
              <p className="drop-shadow-1xl text-lg lg:text-2xl font-bold bg-gradient-to-r from-accent via-indigo-500 to-accent inline-block text-transparent bg-clip-text">
                {soma?.toLocaleString("pt-BR", {
                  maximumFractionDigits: 2,
                })}{" "}
                kWh
              </p>
            </div>
          </div>
          <ChartBarViewDefault
            typeChart="consumoSalaMaquinas"
            nameSerie="Consumo ( kWh )"
            chartDataProps={res}
          />
        </div>
      </CardLayout>
    </>
  );
};

export default ConsumoSalaMaquinas;